import React from 'react';

import { ClickableIcon } from '~components';
import { faArrowUpRightFromSquare } from '~components/icon';
import { Row } from '~components/table-view';

interface ComponentProps {
  row?: Row;
}

const DexReadinessActionCell: React.FC<ComponentProps> = ({ row }) => {
  const handleClick = () => {
    if (row?.appointment_id) {
      window.open(`/appointments/${row.appointment_id}?tab=dex`, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <ClickableIcon
      id={`dex-readiness-action-${row?.appointment_id ?? 'unknown'}`}
      icon={faArrowUpRightFromSquare}
      onClick={handleClick}
      toolTip="Open appointment"
      ariaLabel="Open appointment"
      dataCy={`dex-readiness-action-${row?.appointment_id ?? 'unknown'}`}
    />
  );
};

export default DexReadinessActionCell;
